import {BlobDetail, NoteReference} from 'notebook/ELNConstants';

export enum DocumentExportActionType {
  // Fired after we've loaded a file into its Store with the Chips that are within the Entry
  LOAD_NOTE_REFERENCES = 'LOAD_NOTE_REFERENCES',

  // Fired after we've loaded a file into its Store with Result Blobs
  LOAD_BLOB_DETAILS = 'LOAD_BLOB_DETAILS',
}

interface DocumentExportActionLoadNoteReferences {
  type: DocumentExportActionType.LOAD_NOTE_REFERENCES;
  fileId: string;
  noteReferences: Array<NoteReference>;
}

interface DocumentExportActionLoadBlobReferences {
  type: DocumentExportActionType.LOAD_BLOB_DETAILS;
  fileId: string;
  blobDetails: Array<BlobDetail>;
}

export function noteReferencesLoaded(
  entryId: string,
  noteReferences?: Array<NoteReference>
): DocumentExportActionLoadNoteReferences {
  return {
    type: DocumentExportActionType.LOAD_NOTE_REFERENCES,
    fileId: entryId,
    noteReferences: noteReferences || [],
  };
}

export function blobDetailsLoaded(
  entryId: string,
  blobDetails?: Array<BlobDetail>
): DocumentExportActionLoadBlobReferences {
  return {
    type: DocumentExportActionType.LOAD_BLOB_DETAILS,
    fileId: entryId,
    blobDetails: blobDetails || [],
  };
}

export type DocumentExportAction =
  | DocumentExportActionLoadNoteReferences
  | DocumentExportActionLoadBlobReferences;
